import { getHeaderDataUrl } from "@/courses/urls.js";
import { transformPayloadToSnakeCase } from "@/courses/utilities/transforms.js";

import { getCourse } from "@/courses/services/CourseService.js";
export const courseModule = {
  namespaced: true,
  state: {
    currentCourse: {
      default_badge_icon: "/assets/badge.png",
      termFor: {
        default: "None found",
      },
    },
    headerData: {},
    courseId: null,
  },
  getters: {
    hasLearningObjectives(state) {
      return state.currentCourse?.has_learning_objectives;
    },
    hasBadges(state) {
      return state.currentCourse?.has_badges;
    },
    includeChallengeScores(state) {
      return state.currentCourse?.include_challenge_scores;
    },
    studentWeighted(state) {
      return state.currentCourse?.student_weighted;
    },
    objectivesAwardPoints(state) {
      return state.currentCourse?.objectives_award_points || false;
    },
    termForAssignment(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_assignment
        : "assignment";
    },
    termForAssignmentType(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_assignment_type
        : "assignment type";
    },
    termForBadge(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_badge
        : "badge";
    },
    termForChallenge(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_challenge
        : "challenge";
    },
    termForFail(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_fail
        : "fail";
    },
    termForGradePredictor(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_grade_predictor
        : "grade predictor";
    },
    termForGroup(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_group
        : "group";
    },
    termForGSI(state) {
      return state.currentCourse.id ? state.currentCourse.term_for_gsi : "gsi";
    },
    termForLearningObjective(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_learning_objective
        : "learning objective";
    },
    termForPass(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_pass
        : "pass";
    },
    termForStudent(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_student
        : "student";
    },
    termForTeam(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_team
        : "team";
    },
    termForWeight(state) {
      return state.currentCourse.id
        ? state.currentCourse.term_for_weight
        : "weight";
    },
  },
  actions: {
    getCurrentCourse: async function ({ commit }, courseId) {
      const { data } = await getCourse(courseId);
      const legacyFormat = transformPayloadToSnakeCase(data);
      const course = { ...legacyFormat };
      commit("setCurrentCourse", course);
      return data;
    },
    getHeaderData: async function ({ commit }, courseId) {
      const resp = await fetch(getHeaderDataUrl.stringify({ courseId }));
      if (resp.status === 404) {
        console.log(resp.status);
      } else if (!resp.ok) {
        throw resp;
      }
      const json = await resp.json();
      commit("setHeaderData", json);
    },
  },
  mutations: {
    setCurrentCourse(state, course) {
      state.currentCourse = course;
    },
    setHeaderData(state, data) {
      state.headerData = data;
    },
    setCourseId(state, num) {
      state.courseId = num;
    },
  },
};
